import { useLocation } from 'react-router'
import Contato from './contato'
import Menu from './menu'

// Rotas que têm chrome próprio (header/identidade) e não devem exibir o
// Menu/Contato globais do site institucional. Ex.: playbook interno Nex2AI.
const HIDDEN_PATHS = ['/backwards-next-to-ia', '/backwards-omnicore']

export default function SiteChrome() {
  const { pathname } = useLocation()

  if (HIDDEN_PATHS.includes(pathname)) {
    return null
  }

  return (
    <>
      <Menu />
      <Contato />
    </>
  )
}
